module.exports = __webpack_public_path__ + "static/media/Asset 5.1@3x.37ced85f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 5.1@3x.png
// module id = 2392
// module chunks = 0